<div id="app-wrap">
  <app-sidebar [primaryRoute]="primaryRoute" id="app-sidebar"></app-sidebar>
  <router-outlet id="right-section"></router-outlet>
</div>